export const GETUSERPROFILE = "GETUSERPROFILE";
export const CLEARDOC = "CLEARDOC";

